import LinkPage from '../components/link-page';
import LinkBrandfolder from '../components/link-brandfolder';

// the keys come from Contentful content block IDs
export default {
  page: LinkPage,
  brandfolderAsset: LinkBrandfolder,
};
